module.exports = __webpack_public_path__ + "static/media/reshape_white.d9be0934.svg";